<h2>
  {{ translationService.getResinsText() }}
</h2>

@if (resins.length) {
  <mat-nav-list>
    @for (resin of resins; track resin; let i = $index; let last = $last) {
      <a
        mat-list-item
        (keydown)="onKeydown($event, i)"
        [attr.tabindex]="i === 0 ? 0 : -1"
        [ngClass]="{
          valid: resin.validationStatus === validationStatuses.VALID,
          invalid: resin.validationStatus === validationStatuses.INVALID,
        }"
      >
        <span matListItemLine>
          <span class="bold">{{ translationService.getResinCodeText() }}:</span>
          {{ resin.resinCode }}
        </span>

        <span matListItemLine>
          <span class="bold"
            >{{ translationService.getFullResinTitleText() }}:</span
          >
          {{ resin.fullResinTitle }}
        </span>

        <span matListItemLine>
          <span class="bold">{{ translationService.getNapcsCodeText() }}:</span>
          {{ resin.napcsCode }}
        </span>

        <span matListItemLine>
          <span class="bold"
            >{{ translationService.getSourceTypeText() }}:</span
          >
          {{ resin.sourceType }}
        </span>

        <span matListItemLine>
          <span class="bold"
            >{{ translationService.getProductWeightKgText() }}:</span
          >
          {{ resin.productWeightKg }}
        </span>
      </a>

      @if (!last) {
        <mat-divider></mat-divider>
      }
    }
  </mat-nav-list>
} @else {
  <span>{{ translationService.getNoResinsFoundText() }}</span>
}
